enum licenseTypeEnum {
    "居民身份证" = 1,
    "中国护照" = 2,
    "港澳居民来往内地通行证" = 3,
    "中华人民共和国港澳居民居住证" = 4,
    "台湾居民来往大陆通行证" = 5,
    "中华人民共和国台湾居民居住证" = 6,
    "外国护照" = 7,
    "外国人永久居留身份证（外国人永久居留证）" = 8,
    "中华人民共和国外国人工作许可证（A类）" = 9,
    "中华人民共和国外国人工作许可证（B类）" = 10,
    "中华人民共和国外国人工作许可证（C类）" = 11,
}

// 辅助核算 部门选择
interface licenseType {
	name: string;
	id: string;
}


let idTypeList: licenseType[] = [
    {
        name: "居民身份证",
        id: "1"
    },
    {
        name: "中国护照",
        id: "2"
    },
    {
        name: "港澳居民来往内地通行证",
        id: "3"
    },
    {
        name: "中华人民共和国港澳居民居住证",
        id: "4"
    },
    {
        name: "台湾居民来往大陆通行证",
        id: "5"
    },
    {
        name: "中华人民共和国台湾居民居住证",
        id: "6"
    },
    {
        name: "外国护照",
        id: "7"
    },
    {
        name: "外国人永久居留身份证（外国人永久居留证）",
        id: "8"
    },
    {
        name: "中华人民共和国外国人工作许可证（A类）",
        id: "9"
    },
    {
        name: "中华人民共和国外国人工作许可证（B类）",
        id: "10"
    },
    {
        name: "中华人民共和国外国人工作许可证（C类）",
        id: "11"
    },
];
export default idTypeList;
